import { config } from '../config';

const URL = config.REST_URL;
const API_URL = config.API_URL;
const DATA_LAYER_URL = config.DATA_LAYER;

export const MINT_NFT_URL = `${URL}/onft/onfts/mint`;
export const LIST_NFT_URL = `${URL}/marketplace/list-nft`;
export const CHANNELS_URL = `${API_URL}/channels`;
const DEFAULT_LIMIT = 5000;

export const urlFetchBalance = (address) => `${URL}/cosmos/bank/v1beta1/balances/${address}`;
export const urlFetchAllowances = (address) => `${URL}/cosmos/feegrant/v1beta1/allowances/${address}`;
export const urlFetchNFTList = (ID) => `${URL}/onft/collections/${ID}?limit=${DEFAULT_LIMIT}`;
export const urlFetchNFT = (denomID, onftId) => `${URL}/onft/asset/${denomID}/${onftId}`;
export const urlTransferNFT = (denomID, onftId) => `${URL}/onft/onfts/${denomID}/${onftId}/transfer`;
export const urlTransferDenom = (denomID) => `${URL}/onft/denoms/${denomID}/transfer`;
export const urlNFT = (collectionID, nftID) => `${DATA_LAYER_URL}/collections/${collectionID}/nfts/${nftID}`;

export const urlDeList = (ID) =>
    `${URL}/marketplace/listings/${ID}/de-list-nft`;

export const urlRemoverMinterContract = (ID) => `${API_URL}/channels/${ID}/remove-minter-contract`;
export const urlFetchIBCBalance = (url, address) => `${url}/cosmos/bank/v1beta1/balances/${address}`;
export const urlDeleteIVVideoMint = (ID) => `${API_URL}/interactive-videos/${ID}/disable-video-mint`;
export const urlFetchTimeoutHeight = (url, channel) => {
    let version = 'v1';
    if (url.indexOf('bluenet') > -1) {
        version = 'v1beta1';
    }

    return `${url}/ibc/core/channel/${version}/channels/${channel}/ports/transfer`;
};

export const urlFetchChannels = (skip, limit, search, status) => {
    const params = ['sortBy=created_at', 'order=desc', 'publishable=true', 'statuses[]=ACTIVE'];
    if (status) {
        params.push(`status=${status}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${API_URL}/channels?${params.join('&')}`;
};
export const urlFetchChannelAvailability = () => `${API_URL}/channels/username-availability-check`;
export const urlFetchChannel = (id) => `${API_URL}/channels/${id}`;
export const urlFetchChannelIV = (id, skip, limit, search, status) => {
    const params = ['sortBy=created_at', 'order=desc'];
    if (status) {
        params.push(`status=${status}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${API_URL}/channels/${id}/interactive-videos?${params.join('&')}`;
};

// pagination
export const urlFetchCollections = (address, skip, limit, search) => {
    const params = ['sortBy=created_at', 'order=desc'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${DATA_LAYER_URL}/collections?creator=${address}&${params.join('&')}`;
};

export const urlFetchNonContractCollections = (address, skip, limit, search) => {
    const params = ['sortBy=created_at', 'order=desc', 'isContractOwned=false'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${DATA_LAYER_URL}/collections?creator=${address}&${params.join('&')}`;
};

export const urlFetchAllCollections = (skip, limit, search) => {
    const params = ['sortBy=created_at', 'order=desc'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${DATA_LAYER_URL}/collections?${params.join('&')}`;
};

export const urlFetchNFTListOwned = (address, skip, limit, search) => {
    const params = ['listed=false', 'sortBy=created_at', 'order=desc'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${DATA_LAYER_URL}/nfts?owner=${address}&${params.join('&')}`;
};

export const urlFetchNFTListAll = (address, skip, limit, search) => {
    const params = ['sortBy=created_at', 'order=desc'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${DATA_LAYER_URL}/nfts?owner=${address}&${params.join('&')}`;
};

export const urlFetchListings = (address, skip, limit, search, priceDenom, minPrice, maxPrice) => {
    const params = ['sortBy=created_at', 'order=desc'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }
    if (priceDenom && priceDenom.length > 0) {
        priceDenom && priceDenom.length > 0 && priceDenom.map((val) => {
            return params.push('priceDenoms[]=' + val);
        });
    }
    if (minPrice) {
        params.push(`priceFrom=${minPrice}`);
    }
    if (maxPrice) {
        params.push(`priceTo=${maxPrice}`);
    }

    return `${DATA_LAYER_URL}/listings?owner=${address}&${params.join('&')}`;
};

export const urlFetchAuctions = (address, skip, limit, search, priceDenom, minPrice, maxPrice) => {
    const params = ['sortBy=created_at', 'order=desc'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }
    if (priceDenom && priceDenom.length > 0) {
        priceDenom && priceDenom.length > 0 && priceDenom.map((val) => {
            return params.push('priceDenoms[]=' + val);
        });
    }
    if (minPrice) {
        params.push(`priceFrom=${minPrice}`);
    }
    if (maxPrice) {
        params.push(`priceTo=${maxPrice}`);
    }

    return `${DATA_LAYER_URL}/auctions?owner=${address}&${params.join('&')}`;
};

export const urlFetchCollectionInfo = (ID) => {
    return `${DATA_LAYER_URL}/collections/${ID}`;
};

export const urlListedCollectionNfts = (id, address, skip, limit, search, priceDenom, minPrice, maxPrice) => {
    const params = ['denomId=' + id, 'sortBy=created_at', 'order=desc'];

    if (address) {
        params.push(`owner=${address}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }
    if (priceDenom && priceDenom.length > 0) {
        priceDenom && priceDenom.length > 0 && priceDenom.map((val) => {
            return params.push('priceDenoms[]=' + val);
        });
    }
    if (minPrice) {
        params.push(`priceFrom=${minPrice}`);
    }
    if (maxPrice) {
        params.push(`priceTo=${maxPrice}`);
    }

    return `${DATA_LAYER_URL}/listings?${params.join('&')}`;
};

export const urlNonListedCollectionNfts = (id, address, skip, limit, search) => {
    const params = ['denomId=' + id, 'listed=false', 'transferable=true', 'sortBy=created_at', 'order=desc'];

    if (address) {
        params.push(`owner=${address}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${DATA_LAYER_URL}/nfts?${params.join('&')}`;
};

export const urlNonTransferableCollectionNfts = (id, address, skip, limit, search) => {
    const params = ['denomId=' + id, 'transferable=false', 'sortBy=created_at', 'order=desc'];

    if (address) {
        params.push(`owner=${address}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${DATA_LAYER_URL}/nfts?${params.join('&')}`;
};

export const urlCollectionAuctionNfts = (id, address, skip, limit, search) => {
    const params = ['denomId=' + id, 'sortBy=created_at', 'order=desc'];

    if (address) {
        params.push(`owner=${address}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${DATA_LAYER_URL}/auctions?${params.join('&')}`;
};

export const urlFetchMyInteractiveVideos = (address, skip, limit, search) => {
    const params = ['sortBy=created_at', 'order=desc'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${API_URL}/my/interactive-videos?owner=${address}&${params.join('&')}`;
};
export const urlFetchMyIvVideoMint = (contractAddress, skip, limit, search, publishStatuses) => {
    const params = ['sortBy=created_at', 'order=desc', 'videoMintsEnabled=true'];
    if (contractAddress) {
        params.push(`contractAddress=${contractAddress}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }
    if (publishStatuses) {
        params.push(`publishStatuses[]=${publishStatuses}`);
    }

    return `${API_URL}/my/interactive-videos?${params.join('&')}`;
};

export const urlFetchInteractiveVideos = (skip, limit, search, status, publishStatuses) => {
    const params = ['sortBy=created_at', 'order=desc'];
    if (status) {
        params.push(`status=${status}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }
    if (publishStatuses) {
        params.push(`publishStatuses[]=${publishStatuses}`);
    }

    return `${API_URL}/my/interactive-videos?${params.join('&')}`;
};

export const urlFetchVODInteractiveVideos = (skip, limit, search, status, publishStatuses, vod) => {
    const params = ['sortBy=created_at', 'order=desc'];
    if (status) {
        params.push(`status=${status}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }
    if (publishStatuses) {
        params.push(`publishStatuses[]=${publishStatuses}`);
    }
    if (vod) {
        params.push('isVOD=true');
    }

    return `${API_URL}/my/interactive-videos?${params.join('&')}`;
};

export const urlFetchLeaderboard = (id, skip, limit, sort, order, search) => {
    const params = ['total=true'];
    if (search && search !== '') {
        params.push(`search=${search}`);
    }

    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (sort) {
        params.push(`sortOn=${sort}`);
    } else {
        params.push('sortOn=created_at');
    }
    if (order) {
        if (order === 'asc') {
            params.push('order=1');
        } else {
            params.push('order=-1');
        }
    } else {
        params.push('order=-1');
    }
    return `${API_URL}/public/interactive-videos/${id}/participants?${params.join('&')}`;
};

export const urlTokenProtectedVideos = (skip, limit, search, status) => {
    const params = ['gatedIV=true', 'sortBy=created_at', 'order=desc'];
    if (status) {
        params.push(`status=${status}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${API_URL}/my/interactive-videos?${params.join('&')}`;
};

export const urlVideoMints = (skip, limit, search, status) => {
    const params = ['videoMintsEnabled=true', 'sortBy=created_at', 'order=desc'];
    if (status) {
        params.push(`status=${status}`);
    }
    if (search !== '' && search !== undefined) {
        params.push(`searchKey=${search}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }

    return `${API_URL}/my/interactive-videos?${params.join('&')}`;
};

export const urlParticipationNftsList = (skip, limit, search, status) => {
    const params = ['participantNFT=true', 'sortBy=created_at', 'order=desc'];
    if (status) {
        params.push(`status=${status}`);
    }
    if (search !== '' && search !== undefined) {
        params.push(`searchKey=${search}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }

    return `${API_URL}/my/interactive-videos?${params.join('&')}`;
};

export const urlFetchMinterContract = (admin, skip, limit, search) => {
    const params = [];
    if (admin) {
        params.push(`admin=${admin}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${DATA_LAYER_URL}/minter-contracts?${params.join('&')}`;
};

export const urlFetchMinterContractDetails = (id) => `${DATA_LAYER_URL}/minter-contracts/${id}`;

export const urlFetchWhitelistContract = (sender, skip, limit, search) => {
    const params = [];
    if (sender) {
        params.push(`sender=${sender}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${DATA_LAYER_URL}/whitelist-contracts?${params.join('&')}`;
};

export const urlFetchWhitelistContractDetails = (id) => `${DATA_LAYER_URL}/whitelist-contracts/${id}`;

// Channel Contract
export const CHANNEL_CONTRACT_ADDRESS_URL = `${API_URL}/get-channel-contract-address`;
export const urlFetchChannelContractAvailability = (address, contractAddress) => {
    const params = [];
    if (address) {
        params.push(`accountAddress=${address}`);
    }
    if (contractAddress) {
        params.push(`contractAddress=${contractAddress}`);
    }

    return `${DATA_LAYER_URL}/channels/username-availability-check?${params.join('&')}`;
};
export const urlFetchChannelContract = (id, address) => `${DATA_LAYER_URL}/channels/${id}?contractAddress=${address}`;
export const urlFetchChannelContracts = (contractAddress, creator, skip, limit, search, status) => {
    const params = ['sortBy=created_at', 'order=desc', 'publishable=true'];
    if (status) {
        params.push(`status=${status}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }
    if (creator) {
        params.push(`owner=${creator}`);
    }
    if (contractAddress) {
        params.push(`contractAddress=${contractAddress}`);
    }

    return `${DATA_LAYER_URL}/channels?${params.join('&')}`;
};

export const urlFetchChannelAssets = (address, id, skip, limit) => {
    const params = ['sortBy=created_at', 'order=desc'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (address) {
        params.push(`contractAddress=${address}`);
    }

    return `${DATA_LAYER_URL}/channels/${id}/assets?${params.join('&')}`;
};

export const urlFetchChannelContractIV = (id, skip, limit, search) => {
    const params = ['sortBy=created_at', 'order=desc', 'isV2=true'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${API_URL}/channels/${id}/interactive-videos?${params.join('&')}`;
};

export const urlFetchChannelContractVODs = (id, skip, limit, search) => {
    const params = ['sortBy=created_at', 'order=desc', 'isV2=true', 'isVOD=true'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${API_URL}/channels/${id}/interactive-videos?${params.join('&')}`;
};

export const urlFetchContractInteractiveVideos = (id, skip, limit, search) => {
    const params = ['sortBy=created_at', 'order=desc', 'isV2=true', 'isVOD=false'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${API_URL}/channels/${id}/interactive-videos?${params.join('&')}`;
};

export const urlFetchContractVideoMints = (id, skip, limit, search) => {
    const params = ['sortBy=created_at', 'order=desc', 'isV2=true', 'videoMintsEnabled=true'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${API_URL}/channels/${id}/interactive-videos?${params.join('&')}`;
};

export const urlFetchContractVideoDrops = (id, skip, limit, search) => {
    const params = ['sortBy=created_at', 'order=desc', 'isV2=true', 'participantNFT=true'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${API_URL}/channels/${id}/interactive-videos?${params.join('&')}`;
};

export const urlFetchContractUpcomingIV = (id, skip, limit, search) => {
    const params = ['sortBy=created_at', 'order=desc', 'isV2=true', 'status=upcoming'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${API_URL}/channels/${id}/interactive-videos?${params.join('&')}`;
};

export const urlFetchContractGatedIV = (id, skip, limit, search) => {
    const params = ['sortBy=created_at', 'order=desc', 'isV2=true', 'isTokenProtected=true'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (search && search !== '') {
        params.push(`searchKey=${search}`);
    }

    return `${API_URL}/channels/${id}/interactive-videos?${params.join('&')}`;
};

export const urlFetchChannelLiveStreams = (contractAddress, username, skip, limit) => {
    const params = ['sortBy=created_at', 'order=desc'];
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }
    if (contractAddress) {
        params.push(`contractAddress=${contractAddress}`);
    }

    return `${API_URL}/my/channels/${username}/live-streams?${params.join('&')}`;
};

export const urlChannelVideoStats = (channelID) => {
    return `${API_URL}/my/channels/${channelID}/interactive-videos/stats`;
};

// published assets
export const urlFetchPublishedAssets = (owner, skip, limit) => {
    const params = ['sortBy=created_at', 'order=desc'];
    if (owner) {
        params.push(`creator=${owner}`);
    }
    if (skip) {
        params.push(`skip=${skip}`);
    }
    if (limit) {
        params.push(`limit=${limit}`);
    }

    return `${DATA_LAYER_URL}/published-assets?${params.join('&')}`;
};

export const urlFetchPublishedAsset = (id) => `${DATA_LAYER_URL}/published-assets/${id}`;

// channel migration
export const urlChannelMigration = (id) => `${API_URL}/my/channel/${id}/migrate`;
export const urlChannelMigrationStatus = (id) => `${API_URL}/my/channel/${id}/migrate/status`;
export const CHANNEL_MIGRATION_AUTHZ_ADDRESS_URL = `${API_URL}/get-channel-migration-authz-account-address`;
export const urlRetryChannelMigration = (id) => `${API_URL}/my/channel/${id}/retry-migration`;
